export default class MailAlias {
  name!: string | null;
  targetAddresses!: string[] | null;

  constructor() {
    this.name = null;
    this.targetAddresses = null;
  }
}
